import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ActionDialogPayload } from "@/hooks/useActionDialog";

interface ApplicationActionDialogProps {
  dialog: ActionDialogPayload | null;
  onClose: () => void;
}

export const ApplicationActionDialog: React.FC<ApplicationActionDialogProps> = ({
  dialog,
  onClose,
}) => {
  const acknowledgeLabel = dialog?.acknowledgeLabel ?? "Got it";

  return (
    <Dialog
      open={Boolean(dialog)}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{dialog?.title ?? "Action required"}</DialogTitle>
          {dialog?.description && (
            <DialogDescription>{dialog.description}</DialogDescription>
          )}
        </DialogHeader>

        {dialog?.items?.length ? (
          <ul className="space-y-2 text-sm text-slate-600">
            {dialog.items.map((item, index) => (
              <li key={`${item}-${index}`} className="flex items-start gap-2">
                <span className="mt-1 block h-1.5 w-1.5 rounded-full bg-[#7b2a40]" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        ) : null}

        <DialogFooter>
          <Button type="button" onClick={onClose}>
            {acknowledgeLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
